import {
  Box,
  Button,
  ColumnLayout,
  FormField,
  NonCancelableCustomEvent,
  Select,
  SelectProps,
} from '@amzn/awsui-components-core';
import React, { useContext, useEffect, useState } from 'react';
import { getDefaultFilterSelection } from '../../api/UtilsApi';
import { naturalSort } from '../utils/SelectOptions';
import { PublicationItem } from './APGLUserProfileUtils';
import { MoveVerticallyHandle } from '../common/MoveVerticallyHandle';
import { AppContext } from '../../contexts/AppContext';
import { convertEntities } from '@amzn/awscat-editor';

interface Props {
  contentNameMap: Map<string, string>;
  allPubs: string[];
  selectedPub: PublicationItem;
  handleSelectionChanged: (pub: PublicationItem) => void;
  handleSelectionDeleted: (id: number) => void;
  duplicationAlert?: string;
}

const PublicationSelection: React.FunctionComponent<Props> = (props: Props) => {
  const {
    contentNameMap,
    allPubs,
    selectedPub,
    duplicationAlert,
    handleSelectionChanged,
    handleSelectionDeleted,
  } = props;
  const { contentId, id } = selectedPub;
  const appContext = useContext(AppContext);
  const entities = appContext?.entities || {};

  const contentOptions: SelectProps.Option[] = naturalSort(
    allPubs.map((pid) => ({
      label: convertEntities(contentNameMap.get(pid) || pid, entities),
      value: pid,
    })),
  );

  const selectedContent = contentId
    ? getDefaultFilterSelection(
        contentId,
        convertEntities(contentNameMap.get(contentId) || contentId, entities),
        contentId,
      )
    : null;

  const [content, setContent] = useState<string>(contentId);
  // @ts-expect-error TS2345 - strict migration
  const [contentSelection, setContentSelection] = useState<SelectProps.Option>(selectedContent);

  useEffect(() => {
    handleSelectionChanged({ contentId: content, id });
  }, [content]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelectionChanged = (event: NonCancelableCustomEvent<SelectProps.ChangeDetail>) => {
    // @ts-expect-error TS2345 - strict migration
    setContent(event.detail.selectedOption.value);
    setContentSelection(event.detail.selectedOption);
  };

  const onDeleteSelection = () => {
    handleSelectionDeleted(id);
  };

  return (
    <ColumnLayout columns={2}>
      <FormField errorText={duplicationAlert} stretch i18nStrings={{ errorIconAriaLabel: 'Error' }}>
        <Select
          selectedOption={contentSelection}
          options={contentOptions}
          onChange={onSelectionChanged}
          placeholder={'Select publication'}
          ariaRequired
        />
      </FormField>
      <Box>
        <div id="delete-publication-icon">
          <Button
            className="cursor-pointer"
            variant="icon"
            iconUrl={'/images/icon-delete.svg'}
            iconAlt="Delete"
            ariaLabel="Delete publication selection"
            onClick={onDeleteSelection}
          />
        </div>
        <div id="sort-publication-icon">
          <MoveVerticallyHandle />
        </div>
      </Box>
    </ColumnLayout>
  );
};

export default PublicationSelection;
